import { Box, Card, CardActionArea, CardContent, Grid2 as Grid, Stack, Typography } from "@mui/material";
import { PageHeader } from "@/components/PageHeader";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/store/auth";

interface Tile {
  title: string; description: string; path: string;
  icon: React.ReactNode; permission: string;
}

const TILES: Tile[] = [
  { title: "Trial balance", description: "Posted journal totals per account (TC-003 / NFR-ACC01).",
    path: "/reports/trial-balance", icon: <AccountBalanceIcon fontSize="large" />,
    permission: "reports.financial.view" },
  { title: "Stock on hand", description: "Current on-hand qty per item / batch / warehouse, derived from the ledger.",
    path: "/reports/stock-on-hand", icon: <InventoryIcon fontSize="large" />,
    permission: "reports.stock.view" },
  { title: "Near expiry", description: "Batches expiring within 30 / 60 / 90 days.",
    path: "/inventory/near-expiry", icon: <EventBusyIcon fontSize="large" />,
    permission: "inventory.stock.view" },
  { title: "PO status", description: "Open / partial / posted purchase orders grouped by vendor.",
    path: "/reports/po-status", icon: <LocalShippingIcon fontSize="large" />,
    permission: "reports.stock.view" },
  { title: "Daily sales", description: "Net OP billing per day for a date range.",
    path: "/reports/daily-sales", icon: <PointOfSaleIcon fontSize="large" />,
    permission: "reports.management.view" },
  { title: "Consolidated stock", description: "Total on-hand per item across every branch (MVP 2).",
    path: "/reports/consolidated-stock", icon: <InventoryIcon fontSize="large" />,
    permission: "reports.stock.view" },
  { title: "AR / AP aging", description: "Customer + vendor outstanding by 0-30 / 31-60 / 61-90 / 90+ buckets.",
    path: "/reports/aging", icon: <AccountBalanceIcon fontSize="large" />,
    permission: "reports.financial.view" },
];

export function ReportsHubPage() {
  const navigate = useNavigate();
  const hasPermission = useAuth(s => s.hasPermission);
  const visible = TILES.filter(t => hasPermission(t.permission));

  return (
    <Box>
      <PageHeader breadcrumbs={["Reports"]} title="Reports" />
      <Grid container spacing={2}>
        {visible.map(t => (
          <Grid key={t.path} size={{ xs: 12, sm: 6, md: 4 }}>
            <Card>
              <CardActionArea onClick={() => navigate(t.path)} sx={{ minHeight: 140 }}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="flex-start">
                    <Box sx={{ color: "primary.main" }}>{t.icon}</Box>
                    <Stack>
                      <Typography variant="h6">{t.title}</Typography>
                      <Typography variant="body2" color="text.secondary">{t.description}</Typography>
                    </Stack>
                  </Stack>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
